/**
 * "Shop by model" pickers: mobile drawer (snippets/voge-drawer-menu.liquid) and desktop mega menu
 * (snippets/voge-mega-models.liquid).
 * Highlights the "My bike" model card (ink border + "My bike" tag) and keeps it in sync with
 * changes from the header / drawer selector (mybike:change, also across tabs).
 * Cards carry data-model-id = collection ID (same ID stored by assets/my-bike.js).
 */
import { getBike, MY_BIKE_EVENT } from '@theme/my-bike';

class VogeModelPicker extends HTMLElement {
  connectedCallback() {
    this.update();
    document.addEventListener(MY_BIKE_EVENT, this.update);
  }

  disconnectedCallback() {
    document.removeEventListener(MY_BIKE_EVENT, this.update);
  }

  update = () => {
    const bike = getBike();
    const bikeId = bike ? String(bike.id) : '';
    this.querySelectorAll('[data-model-id]').forEach((card) => {
      const active = bikeId !== '' && card.getAttribute('data-model-id') === bikeId;
      card.classList.toggle('is-my-bike', active);
      const tag = card.querySelector('.vd-model__tag, .voge-mega__tag');
      if (tag instanceof HTMLElement) tag.hidden = !active;
    });
  };
}

if (!customElements.get('voge-model-picker')) {
  customElements.define('voge-model-picker', VogeModelPicker);
}
